import {NEW_OUTPUT_ID, NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {LocationCardData} from '../../scratchpad/locationCardScratchpad.types';
import {sharedCampaigns} from '@cl/shared';
import {DTStoreNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {CLStore} from 'common/src/redux/store';
import {DefaultMaxDistKm} from '../../../../schemas/locationCardSchema';

function createDefaultLocationCard(): LocationCardData {
  return {
    id: NO_NODE_ID,
    name: 'Location Card',
    description: '',
    type: NodeType.STORE,
    outputs: [
      {
        id: NEW_OUTPUT_ID,
        name: 'Success',
        type: OutputType.Regular,
        nodeId: NO_NODE_ID,
      },
      {
        id: NEW_OUTPUT_ID,
        name: 'Fallback',
        type: OutputType.Fallback,
        nodeId: NO_NODE_ID,
      },
    ],
    inputs: [],
    nextOutputId: 1,
    locationFeedId: 0,
    locationSetId: 0,
    locationTargetingMethod: 0,
    maxDistFallbackOption: 0,
    maxDistKm: DefaultMaxDistKm,
    topLocationIds: [],
  };
}

/**
 * Gets an existing location card by ID, or creates a new default one.
 * @param cardId - The card ID to fetch, or 0/undefined for a new card
 * @returns The location card (existing or new), fully mutable
 */
async function getOrCreateLocationCard(
  cardId: number | undefined,
  _store: CLStore,
): Promise<LocationCardData> {
  const resolvedCardId = cardId && cardId > NO_NODE_ID ? cardId : NO_NODE_ID;

  if (resolvedCardId) {
    const existingCard = sharedCampaigns.nodesRef.value[resolvedCardId];

    if (!existingCard) {
      throw new Error(`Card with id ${resolvedCardId} not found`);
    }

    if (existingCard.type !== NodeType.STORE) {
      throw new Error(`Card with id ${resolvedCardId} is not a location card`);
    }

    const storeNode = existingCard as DTStoreNode;

    return {
      ...storeNode,
    } as LocationCardData;
  }

  return createDefaultLocationCard();
}

export default getOrCreateLocationCard;
